;(function(){
    var lua = function(str){
        if (!Module || !Module.CasinoUtilsExecuteLua) return;
        Module.CasinoUtilsExecuteLua(str);
    };

    //add analytics for play_on_phone clicks
    var monitor = setInterval(function(){
        var elem = document.activeElement;
        if(elem && elem.classList.contains('play_on_phone')){
            clearInterval(monitor);
            lua("jsCallbacks:OnPlayOnPhoneClicked()");
        }
    }, 200);

})();



//////////////////
// WEBPACK FOOTER
// /src/src/platform/emscripten/Application.analytics.js
// module id = 21
// module chunks = 0